import styled, { keyframes } from "styled-components";
import UiButton from "components/operations/decisions/ui-button";
import Teams from "../../api/Teams";

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #fafafa;
  padding: 40px 40px 0;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

Styled.Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  padding-right: 20px;
`;

Styled.Subtitle = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.7);
  margin-top: 4px;
  margin-bottom: 12px;
`;

Styled.SubmitDecisionButton = styled.div`
  display: inline-block;
  height: 23px;
  width: 148px;
  line-height: 23px;
  text-align: center;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)"};
  border-radius: 5px;

  .fa-spinner,
  .fa-check {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
  }
`;

Styled.BlocksRow = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  max-width: 1200px;
`;

Styled.GoogleMap = styled.div`
  width: 100%;
  border-bottom: 1px solid #d5d9dd;
  position: relative;

  img {
    width: 100%;
  }
`;

Styled.MapDot = styled.div`
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 1.5px solid #5c91f5;
  border-radius: 100px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 10px;
  color: #5c91f5;
  cursor: default;

  ${p => p.onMouseEnter && `
    cursor: pointer;

    &:hover {
      background: #5c91f5;
      border-color: #5c91f5;
      color: #ffffff;
    }
  `}

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  // x/y anchor the CENTER of the dot (not its top-left corner). This
  // matches the intuition of "the dot sits at this point on the map".
  transform: translate(-50%, -50%);

  ${p => p.y && `
    top: ${p.y}px;
  `}

  ${p => p.x && `
    left: ${p.x}px;
  `}
  
  ${p => p.yPercentage && `
    top: ${p.yPercentage}%;
  `}

  ${p => p.xPercentage && `
    left: ${p.xPercentage}%;
  `}
`;

Styled.DistributionTableRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 7px;

  margin-top: 4px;

  ${p => p.marginTop && `
    margin-top: ${p.marginTop}px;
  `}
`;

Styled.DistributionTableCell = styled.div`
  flex: 1;
  background: rgba(0, 27, 43, 0.02);
  border-radius: 2px;
  padding: 2px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.isHeader && `
    font-weight: 700;
    background: none;

    span {
      font-weight: 400;
    }
  `}
`;

Styled.DistributionButtons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

Styled.DistributionCancelButton = styled.div`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 40px;
  outline: none;
  cursor: pointer;
  border: 1.5px solid #5C91F5;
  border-radius: 4px;
  text-align: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  color: #5c91f5;
`;

Styled.DistributionSubmitButton = styled.div`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 40px;
  outline: none;
  cursor: pointer;
  background: #5c91f5;
  border-radius: 4px;
  text-align: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  color: #ffffff;

  &:disabled, &[disabled] {
    background: #d5d9dd;
    cursor: pointer;
  }
`;

Styled.DistributionInfo = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.6);

  margin-top: 10px;

  span {
    color: red;
  }
`;

Styled.Tooltip1 = styled.div`
  position: absolute;
  width: 240px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08), 0px 6px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  display: none;
  z-index: 100;

  ${p => p.top && `
    top: ${p.top}px;
  `}

  ${p => p.left && `
    left: ${p.left}px;
  `}

  ${p => p.show && `
    display: block;
  `}
`;

Styled.TooltipTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  span {
    width: 24px;
    height: 24px;
    background: #5c91f5;
    border-radius: 100px;
    display: inline-block;
    margin-right: 4px;

    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    line-height: 24px;
    color: #ffffff;
  }

  padding: 8px 0;

  ${p => p.background && `
    background: ${p.background};
  `}
`;

Styled.TooltipCost = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);

  padding: 8px 16px;

  span {
    color: #5c91f5;
  }

  ${p => p.background && `
    background: ${p.background};
  `}
`;

Styled.TooltipImage = styled.div`
  img {
    width: 100%;
  }
`;

Styled.TooltipButtonRow = styled.div`
  padding: 8px 16px 16px;
`;

Styled.TooltipButton = styled.button`
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
  text-align: center;
  height: 32px;
  border-radius: 4px;
  background: #2a4169;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  color: #ffffff;
`;

Styled.MapIcon = styled.div`
  width: 30px;
  height: 30px;
  cursor: default;

  img {
    width: 30px;
    height: 30px;
  }

  ${p => p.width && `
    width: ${p.width}px;

    img {
      width: ${p.width}px;
    }
  `}

  ${p => p.height && `
    height: ${p.height}px;

    img {
      height: ${p.height}px;
    }
  `}

  ${p => p.isFixed && `
    position: fixed;
    z-index: 2002;
  `}

  ${p => p.isFixed && p.y && `
    top: ${p.y + 230}px;
  `}

  ${p => p.isFixed && p.x && `
    left: ${p.x + 250}px;
  `}

  ${p => !p.isFixed && `
    position: absolute;
  `}

  ${p => !p.isFixed && p.y && `
    top: ${p.y}px;
  `}

  ${p => !p.isFixed && p.x && `
    left: ${p.x}px;
  `}

  ${p => p.onClick && `
    cursor: pointer;
  `}

  ${p => p.onMouseEnter && `
    cursor: pointer;
  `}
`;

Styled.TooltipSpace = styled.div`
    width: 100%;
    height: 8px;
`;

Styled.TopBanner = styled.div`
  width: 100%;
  height: 36px;
  background: #fafafa;
  border-bottom: 1px solid #d5d9dd;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #5c91f5;
`;

Styled.PreDescription = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  max-width: 880px;
  margin-top: 20px;
  margin-bottom: -10px;
`;

Styled.MapDetails = styled.div`
  padding: 20px;

  ${p => p.hide && `
    display: none;
  `}
`;

Styled.MapDetailsTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 16px;

  img {
    // margin-left: 8px;
    position: relative;
    top: -1px;
  }

  ${p => p.margin && `
    margin: ${p.margin};
  `}
`;

Styled.MapDetailsTitleCheckbox = styled.img`
  margin-right: 8px;
  width: 18px;
  height: 18px;
`;

Styled.HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
`;

Styled.WhiteBlock = styled.div`
  flex: 1;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 4px;
  flex: 0 0 50%;
  width: 50%;

  ${p => p.width && `
    flex: 0 0 ${p.width};
    width: ${p.width};
  `}

  ${p => p.autoWidth && `
    flex: 0 0 calc(100vw - 810px);
    width: calc(100vw - 810px);
    max-width: 590px;
  `}

  ${p => p.padding && `
    padding: ${p.padding};
  `}

  ${p => p.mapOverlay && `
    position: fixed;
    z-index: 2001;
  `}
`;

Styled.DistributionTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.ButtonsWrapper = styled.div`
  margin-top: 20px;
`;

Styled.ButtonsWrapperFlex = styled.div`
  display: flex;
  align-items: center;
`;

Styled.UIButton = styled(UiButton)`
  display: block;
  padding: 7px 10px !important;
  min-width: auto !important;
  border-color: transparent !important;
  width: auto !important;
  height: auto !important;
  line-height: 27px !important;
  background-color: #2f4066 !important;
  font-family: 'Mukta Vaani' !important;
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #ffffff !important;
  border-radius: 2px !important;
  transition: background-color 0.5s ease;
  letter-spacing: 0.02em !important;

  &:hover {
    background-color: #55b4bc !important;
  }

  &:disabled {
    background-color: #dadada !important;
    color: #969696 !important;
  }

  &.active {
    background-color: #55b4bc !important;
  }
`;

Styled.Arrow = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;

Styled.Chart = {};

Styled.Chart.TitleRow = styled.div`
  display: flex;
  align-items: center;
`;

Styled.Chart.Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  padding-right: 12px;
`;

Styled.Chart.TitleAmount = styled.div`
  background: #5c91f5;
  border-radius: 4px;
  padding: 2px 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #ffffff;
`;

Styled.Chart.TitleAmountTeam = Styled.Chart.TitleAmount.extend`
  background: ${Teams.currentTeamColor};
`;

Styled.FullWidthRow = styled.div`
  width: 100%;
`;

Styled.Chart.Row = styled.div`
  margin-top: 35px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #000;
  width: 100%;

  .fa {
    font-size: 16px !important;
    color: #8894a7 !important;
  }

  ${p =>
    p.width &&
    `
    width: ${p.width};
  `}
`;

Styled.Chart.Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 15px;
`;

Styled.Chart.Chart = styled.div`
  flex: 0 0 340px;
  margin-top: 10px;
`;

Styled.Chart.Legend = styled.div`
  padding-left: 20px;
`;

Styled.Chart.LegendItem = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #000000;
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

Styled.Chart.LegendItemCircle = styled.div`
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  ${p =>
    p.color &&
    `
    background: ${p.color};
  `};
  margin-right: 13px;
  content: "";
  border-radius: 15px;
`;

Styled.Table = {};

Styled.Table.Wrapper = styled.div`
  margin-top: 35px;
`;

Styled.Table.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #000;
`;

Styled.Table.Table = styled.div`
  table {
    width: 100%;
    border: 0;
    border-collapse: separate;

    thead {
      border: 0;

      tr {
        th {
          padding: 12px 13px;
          font-family: Lato;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #74abec;
          border-bottom: 1px solid #626262;
        }
      }
    }

    tbody {
      tr {
        td {
          border-top: 9px solid #fff;
          font-family: Lato;
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          color: #000000;
          text-align: center;
          padding: 2px 0;

          ${p =>
    p.rowColor &&
    `
            background: ${p.rowColor};
          `}
          .remove-operation {
            line-height: 25px;
            top: 0;
          }
        }

        &:first-child {
          td {
            border-top: 12px solid #fff;
          }
        }
      }
    }
  }
`;

Styled.PercentAmount = styled.div`
  margin-top: 15px;
  font-family: Lato;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #000;
  text-align: center;
  max-width: 120px;
`;

// Dev-only: transparent overlay on top of the map that captures clicks
// and logs the click x/y to the console. Activated by `?devmap=1` URL
// query param so it's not visible to normal users.
Styled.DevMapOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  cursor: crosshair;
  background: rgba(255, 0, 0, 0.04);
`;

Styled.DevMapBanner = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 1001;
  background: #d34c4c;
  color: #fff;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 600;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 4px;
  pointer-events: none;
`;

Styled.DevMapCoord = styled.div`
  position: absolute;
  background: #000;
  color: #fff;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 11px;
  border-radius: 3px;
  pointer-events: none;
  white-space: nowrap;
  top: ${p => p.top + 8}px;
  left: ${p => p.left + 8}px;
`;

// Horizontal row that lays out the three Make Decisions options with
// arrow separators between them, signaling the intended order:
// machines → manufacture → distribution.
Styled.DecisionFlowRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 16px;
`;

Styled.DecisionFlowArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: rgba(0, 27, 59, 0.35);
  flex-shrink: 0;
  padding: 0 4px;
  user-select: none;
`;

// Mirrors FinanceStyled.ManageOptionWrapper but flex:1 so siblings
// inside a DecisionFlowRow size equally.
Styled.DecisionOptionWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;

  > button {
    width: 100%;
  }

  &:hover > span {
    opacity: 1;
    visibility: visible;
  }
`;

// Wrapping variant of FinanceStyled.ManageOptionTooltip — fixed width
// so longer explanatory copy breaks onto multiple lines.
Styled.DecisionOptionTooltip = styled.span`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: rgba(0, 27, 59, 0.94);
  color: #fff;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding: 10px 14px;
  border-radius: 6px;
  width: 260px;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, visibility 0.15s ease;
  pointer-events: none;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: rgba(0, 27, 59, 0.94);
  }
`;

// Round-over-round delta line shown under a KPI value (e.g. Cost Per
// Unit). negative=true (cost went up) renders red with an up arrow;
// otherwise green with a down arrow.
Styled.KpiDelta = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: ${p => p.negative ? '#C62828' : '#2DA548'};
  margin-top: 2px;
`;

// 2-column grid where the left "Market Information" block spans both
// rows on the right (Inventory Management + Supply Chain Assets stack).
Styled.OpsLeadGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  max-width: 1300px;
  margin-bottom: 16px;
  align-items: start;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

Styled.OpsLeadGridMarket = styled.div`
  grid-column: 1;
  grid-row: span 2;

  @media (max-width: 1000px) {
    grid-row: auto;
  }
`;

Styled.OpsLeadGridRight = styled.div`
  grid-column: 2;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;

  ${p => p.fillHeight && `
    grid-row: span 2;
  `}

  @media (max-width: 1000px) {
    grid-column: 1;
  }

  > div {
    margin-bottom: 0;
  }
`;

// Persistent, expanding halo ring around the DC markers when the
// Manage Distribution panel is open — makes the interactive markers
// impossible to miss even at a glance.
const dcRing = keyframes`
  0%   { transform: translate(-50%, -50%) scale(1); opacity: 0.85; }
  100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
`;

// Secondary pulsing halo directly on the icon so there is always a
// visible glow even when the ring is between pulses.
const dcGlow = keyframes`
  0%, 100% { box-shadow: 0 0 12px 4px rgba(92, 145, 245, 0.7), 0 0 26px 10px rgba(92, 145, 245, 0.35); }
  50%      { box-shadow: 0 0 24px 10px rgba(92, 145, 245, 1), 0 0 40px 18px rgba(92, 145, 245, 0.5); }
`;

// Gentle vertical bob so the marker appears to be lifting off the map,
// matching the "Select a Distribution Center" callout above.
const dcBob = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
`;

Styled.GlowingMapIcon = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
  animation: ${dcGlow} 1.4s ease-in-out infinite, ${dcBob} 1.8s ease-in-out infinite;

  ${p => p.y && `top: ${p.y}px;`}
  ${p => p.x && `left: ${p.x}px;`}

  /* Expanding "sonar" ring so the marker is legible even without motion. */
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 3px solid rgba(92, 145, 245, 0.9);
    transform: translate(-50%, -50%) scale(1);
    animation: ${dcRing} 1.8s ease-out infinite;
    pointer-events: none;
  }

  &::after {
    animation-delay: 0.9s;
  }

  &:hover {
    animation: none;
    transform: scale(1.3);
    box-shadow: 0 0 26px 12px rgba(92, 145, 245, 1), 0 0 46px 20px rgba(92, 145, 245, 0.55);

    &::before,
    &::after {
      animation-play-state: paused;
      opacity: 0;
    }
  }

  img {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    z-index: 1;
  }
`;

// Floating callout that instructs the student to pick one of the
// glowing distribution-center markers on the map.
const dcCalloutPulse = keyframes`
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50%      { transform: translateX(-50%) translateY(-4px); }
`;

Styled.SelectDcCallout = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 999px;
  background: #2F4166;
  color: #FFFFFF;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.2px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
  z-index: 5;
  pointer-events: none;
  animation: ${dcCalloutPulse} 1.8s ease-in-out infinite;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #5C91F5;
    box-shadow: 0 0 0 4px rgba(92, 145, 245, 0.35);
  }
`;

// Body paragraph styling for the Manage Distribution side panel.
Styled.ManageDistributionBody = styled.div`
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.7);
  margin-top: 8px;

  p {
    margin: 0 0 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

Styled.ManageDistributionClose = styled.button`
  position: absolute;
  top: 16px;
  right: 18px;
  background: transparent;
  border: none;
  font-size: 22px;
  line-height: 1;
  padding: 4px 8px;
  color: rgba(0, 27, 59, 0.6);
  cursor: pointer;

  &:hover {
    color: rgba(0, 27, 59, 0.94);
  }
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/components/operations/style.js